import { Loader2 } from 'lucide-react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from 'src/components/ui/table';
import type { CreativeTemplateExample } from '../types/creative-template-example.types';

interface CreativeTemplateExampleListProps {
  examples: CreativeTemplateExample[] | undefined;
  isLoading: boolean;
  isError: boolean;
  onSelect: (example: CreativeTemplateExample) => void;
}

export function CreativeTemplateExampleList({
  examples,
  isLoading,
  isError,
  onSelect,
}: CreativeTemplateExampleListProps) {
  if (isLoading) {
    return (
      <div className="flex items-center gap-2 py-8 text-sm text-gray-500" role="status">
        <Loader2 className="size-4 animate-spin text-gray-500" />
        Loading template examples…
      </div>
    );
  }

  if (isError) {
    return (
      <div className="rounded-md border border-red-101 bg-red-101 p-4 text-sm text-red-700" role="alert">
        Could not load template examples. You may need staff or admin access.
      </div>
    );
  }

  if (!examples?.length) {
    return (
      <div className="rounded-md border border-gray-400 bg-gray-50 p-4 text-sm text-gray-600">
        No template examples found. Run the seed command or create a new example.
      </div>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Example</TableHead>
          <TableHead>Profile</TableHead>
          <TableHead>Size</TableHead>
          <TableHead>Demo brand</TableHead>
          <TableHead>Version</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {examples.map((example) => (
          <TableRow key={example.id} className="cursor-pointer" onClick={() => onSelect(example)}>
            <TableCell>
              <div className="font-medium text-black">{example.example_id}</div>
            </TableCell>
            <TableCell>{example.profile_id}</TableCell>
            <TableCell>{example.size_key}</TableCell>
            <TableCell>{example.payload.canonical_demo_brand_slug || '—'}</TableCell>
            <TableCell>{example.version ?? '—'}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
